export interface PermissionsError {
  statusCode: number
  module?: any
}

const error = ref<PermissionsError>(null)

export default function useError() {
  const createError = (statusCode: number, module?: any) => {
    error.value = {
      statusCode,
      module
    }
  }

  const hasError = computed(() => error.value !== null)

  return {
    createError,
    error,
    hasError
  }
}
